import React from 'react';

import './ContactAdvisorBanner.scss';
import Button from '../../Shared/Button/Button';
import {
  openModal,
  FINANCIAL_ADVISOR_MODAL,
} from '../../../redux/modules/modals/modals.module';
import { useDispatch } from 'react-redux';

const ContactAdvisorBanner = ({ hasApp }) => {
  const dispatch = useDispatch();

  return (
    <div className="contact-advisor-banner">
      <div className="body-text">
        {hasApp && (
          <p className="bold-text">
            We recommend consulting with your advisor before making a withdrawal
            from your Retirement Advisory Service account(s).
          </p>
        )}
        {!hasApp && (
          <p className="bold-text">
            We recommend consulting with your advisor before making a
            withdrawal.
          </p>
        )}
        <br />
        <p className="normal-text">
          You can discuss the best strategy for your withdrawal and any
          potential impacts to your financial plan.
        </p>
        <br />
      </div>
      <div className="contact-advisor-button">
        <Button
          className="btn-trp-ghost-bright-blue"
          onClick={() => dispatch(openModal(FINANCIAL_ADVISOR_MODAL))}
        >
          Contact Advisor &nbsp;
          <span className="contact-advisor-icon" />
        </Button>
      </div>
    </div>
  );
};

export default ContactAdvisorBanner;
